import type { PurchaseInfo } from '$lib/types'
import { writable } from 'svelte/store'

export const purchaseInfo = writable<PurchaseInfo>()
export const purchaseInfoReturn = writable<PurchaseInfo>()
export const setPurchaseInfo = (info: PurchaseInfo, tripType?: 'oneWay' | 'return') => {
  if (tripType === 'return') {
    purchaseInfoReturn.set(info)
  } else {
    purchaseInfo.set(info)
  }
}
export const couponCode = writable<string | null>(null)

